module.exports = "/_next/static/images/3f939c8453a41e65d0338203da0fe5d7-product-information-xs-1x.jpg.webp";